import { render, staticRenderFns } from "./OolibaBasicTable.vue?vue&type=template&id=094d3384&"
import script from "./OolibaBasicTable.vue?vue&type=script&lang=js&"
export * from "./OolibaBasicTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports